<template>
  <!--      multiple 是否多选-->
  <!--      http-request 覆盖默认的上传行为，可以自定义上传的实现-->
  <!--      before-upload 上传文件之前的钩子，参数为上传的文件，若返回 false 或者返回 Promise 且被 reject，则停止上传。-->
  <!--      before-remove	删除文件之前的钩子，参数为上传的文件和文件列表，若返回 false 或者返回 Promise 且被 reject，则停止删除。-->

  <!--      on-preview 点击文件列表中已上传的文件时的钩子-->
  <!--      on-remove 文件列表移除文件时的钩子-->
  <!--      on-success 文件上传成功时的钩子-->
  <!--      on-error 文件上传失败时的钩子-->

  <!--      on-progress 文件上传时的钩子-->
  <!--      on-change 文件状态改变时的钩子，添加文件、上传成功和上传失败时都会被调用-->

  <!--      file-list 上传的文件列表, 例如: [{name: 'food.jpg', url: 'https://xxx.cdn.com/xxx.jpg'}]-->

  <el-upload
    multiple
    class="upload-demo"
    :action="actionUrl"
    :accept="acceptStr"
    :before-upload="beforeUpload"
    :on-change="onChange"
    :on-success="onSuccess"
    :on-remove="onRemove"
    :file-list="fileList"
  >
    <el-button size="small" type="primary">{{ $t('button.upload') }}</el-button>
  </el-upload>
</template>

<script>
export default {
  name: 'Upload',
  components: {},
  props: {
    name: String,
    fileList: {
      type: Array
    }
  },
  data() {
    return {
      actionUrl: window.host + '/common/file/upload',
      acceptStr: '',
      acceptArray: ['.jpg', '.jpeg', '.JPG', '.JPEG', '.png', '.gif', '.GIF', '.bmp', '.pdf', '.PDF', '.PBG', '.BMP', '.doc', '.docx', '.xls', '.xlsx', '.rar', '.zip', '.txt']
    }
  },
  mounted() {
    const self = this
    window.upload = self
    self.acceptStr = self.acceptArray.toString()
  },
  methods: {

    /**
    * 上传文件之前的钩子，参数为上传的文件，若返回 false 或者返回 Promise 且被 reject，则停止上传。
    */
    beforeUpload(file) {
      const self = this
      const fileName = file.name
      const suffix = fileName.slice(fileName.lastIndexOf('.'))
      const isFileType = self.acceptArray.indexOf(suffix) !== -1 // 判断上传文件类型中有没有上传的文件
      if (!isFileType) {
        self.$message.warning(self.$t('tipsList.pleaseSelectTheFile') + self.acceptStr)
        return false
      }
      return file
    },

    /**
     * 根据上传组件的列表重新赋值
     */
    resetFileList(fileList) {
      fileList.forEach(item => {
        if (item.response && item.response.code === 200) {
          item.url = item.response.data.path
        }
      })

      // 向父组件传文件列表
      this.$emit('setFileList', fileList, this.name)
    },

    /**
     * 文件上传成功时的钩子
     */
    onSuccess(response, file, fileList) {
      this.resetFileList(fileList)
    },

    /**
     * 文件上传时的钩子
     */
    onProgress(event, file, fileList) {
      debugger
    },

    /**
     * 文件状态改变时的钩子，添加文件、上传成功和上传失败时都会被调用
     */
    onChange(file, fileList) {

    },

    /**
     * 文件列表移除文件时的钩子
     */
    onRemove(file, fileList) {
      this.resetFileList(fileList)
    }

  }
}
</script>

<style scoped lang="scss">
  .upload-demo {
    width: 400px;
  }
</style>
